export let FontFamily;
(function (FontFamily) {
  FontFamily["ARIAL"] = "Arial";
  FontFamily["DEFAULT"] = "default";
  FontFamily["TAHOMA"] = "Tahoma";
  FontFamily["TIMES"] = "Times New Roman";
  FontFamily["VERDANA"] = "Verdana";
})(FontFamily || (FontFamily = {}));
export let FontWeight;
(function (FontWeight) {
  FontWeight["BOLD"] = "bold";
  FontWeight["DEFAULT"] = "default";
})(FontWeight || (FontWeight = {}));
const FontSizes = [8, 9, 10, 12, 14, 16, 18, 20, 24, 28, 32, 36, "default"];
//# sourceMappingURL=Font.js.map